import actionConstants from '../constants/';

const loaderState = {
  actionsLoading: [],
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function loaderReducer(state = loaderState, action) {
  let tempActionsLoading: any[] = [];
  switch (action.type) {
    case actionConstants.START_LOADER:
      return {
        actionsLoading: [...state.actionsLoading, action.payload.actionType],
        loaderMessage: action?.payload?.loaderMessage
      };
    case actionConstants.STOP_LOADER:
      tempActionsLoading = [...state.actionsLoading];
      {
        const actionIndex = tempActionsLoading.indexOf(action.payload.actionType);
        if (actionIndex > -1) {
          tempActionsLoading.splice(actionIndex, 1);
        }
      }
      return {
        actionsLoading: [...tempActionsLoading],
      };
    default:
      return state;
  }
}
